/* eslint-disable @typescript-eslint/no-unused-vars */

//

export function checkNever(type: never): void {
  return;
}
